import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

import ViewLogsForm from '../../components/Forms/ViewLogsForm';
import Spinner from '../../components/UI/Spinner';
import AjaxErrorMessage from '../../components/UI/AjaxErrorMessage';
import Aux from '../../hoc/NoParent';
import ButtonDownload from '../../components/UI/Buttons/ButtonDownload';

import { getServerFormattedDate, getISOFormattedDate } from '../../util/getFormattedDate';
import { loadLogsFromServer } from '../../store/actions/index';
import dataFormatter from '../../util/dataFormatter';

class Logs extends Component {

    state = {
        downloading: false, 
        start: null, 
        end: null 
    }

    onSubmitForm = ({start, end}) => {
        this.setState({ downloading: false, start, end });

        this.props.onLoadLogs(getServerFormattedDate(start), getServerFormattedDate(end), this.props.token);
    }

    render() {
        const { logs, loading, error } = this.props;
        const date = new Date();

        let logsGrid = null;
        let downloadFrame = null;

        if(loading) logsGrid = <Spinner />;

        if(this.state.downloading) {
            const { start, end } = this.state;

            if(start && end) {
                downloadFrame = <iframe title="Download" src={`https://portals.leonardsexpress.com/driver/lite/logs/download?start=${getServerFormattedDate(start)}&end=${getServerFormattedDate(end)}&token=${this.props.token}`} frameBorder="0" style={{width: '1px', height: '1px'}}></iframe>;
            }
        }

        if(logs && logs.length > 0) {
            let i = 0;

            logsGrid = <Aux>
                <div style={{textAlign: 'right'}}>
                    <ButtonDownload onClick={() => this.setState({ downloading: true }) } />
                </div>
                <div style={{overflow: 'auto'}}>
                    <Table className="LogsGrid" size="small">
                        <TableHead>
                            <TableRow className="LogRow">
                                <TableCell>Activity</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Location</TableCell>
                                <TableCell>Start</TableCell>
                                <TableCell className="Tractor">Tractor</TableCell>
                                <TableCell className="Trailer">Trailer</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map(log => <TableRow className="LogRow" key={i++}>
                                <TableCell>{log.hos_status}</TableCell>
                                <TableCell align="right">{log.duration_minutes}</TableCell>
                                <TableCell>{log.status_location}</TableCell>
                                <TableCell>{dataFormatter.toDateTime(log.start_time)}</TableCell>
                                <TableCell className="Tractor">{log.hos_tractor}</TableCell>
                                <TableCell className="Trailer">{log.hos_trailer}</TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </div>
            </Aux>
        }

        return (
            <Aux>
                <ViewLogsForm 
                    initialValues={{start: getISOFormattedDate(date.setDate(date.getDate() -30)), end: getISOFormattedDate(new Date())}} 
                    onSubmit={this.onSubmitForm} />
                {logsGrid}
                {downloadFrame}
                <AjaxErrorMessage error={error} />
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        logs: state.log.logs, 
        loading: state.log.loading, 
        error: state.log.error, 
        token: state.auth.token
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadLogs: (start, end, token) => dispatch(loadLogsFromServer(start, end, token))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Logs);